import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {Eligibility270Component} from './eligibility270.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import {  NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyDatePickerModule } from 'mydatepicker';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {  ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { PhoneNumberFormatService } from 'src/app/phone-number-format.service';
import { NumericTextBoxModule, NumericTextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { Get271Fileservice } from './eligibility271.service';
import { Vieweligibility271Module } from '../vieweligibility271/vieweligibility271.module';
import { Eligibility270RoutingModule } from './eligibility270-routing.module';
import { dropdownModule } from 'src/app/dropdown/dropdown.module';
@NgModule({
  declarations: [Eligibility270Component],
  imports: [
    Eligibility270RoutingModule,
    Vieweligibility271Module,
    CommonModule,
    RadioButtonModule,
    NumericTextBoxModule,
     NumericTextBoxAllModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    DropDownListAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    NgSelectModule,
    MyDatePickerModule,
    PDFExportModule,
    PdfViewerModule,
    NgxUiLoaderModule,
    dropdownModule
  ],
  providers: [ColumnChooserService,PhoneNumberFormatService,PageService,SortService,FilterService, ResizeService,Get271Fileservice],
})
export class Eligibility270Module { }
